import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { LEGAL_ROUTES } from '../config/legal';

const Footer = () => (
  <Box
    component="footer"
    sx={{
      py: 3,
      px: 2,
      mt: 'auto',
      borderTop: 1,
      borderColor: (theme) =>
        theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'divider',
      bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'transparent' : 'background.paper'),
      transition: 'background-color 200ms ease, border-color 200ms ease',
    }}
  >
    <Container maxWidth="sm">
      <Typography variant="body2" color="text.secondary" align="center">
        {'Copyright © '}
        <Link color="inherit" href="https://stacktrack.org/">
          StackTrack
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
        {' · '}
        <Link
          component={RouterLink}
          to={LEGAL_ROUTES.privacy}
          color="inherit"
          underline="hover"
        >
          Privacy Policy
        </Link>
      </Typography>
    </Container>
  </Box>
);

export default Footer;
